import {useSelector} from '../../../store.js'
import {
  updateLabelConfig,
  labelTypeSelector,
} from '../../../data/labelInfos/index.js'
import {DHL_ECOMMERCE} from '../../../common/constants/ShipperNames.js'
import ConfigTextInput from './ConfigTextInput.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {LABEL_TYPE_RETURN} from '../../../common/constants/LabelConfig.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'return_reason'
const VALID_SHIPPER_TYPES = [DHL_ECOMMERCE]

export default function ReturnReason() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = ReturnReason.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const labelType = useSelector((state) =>
    labelTypeSelector(state, {labelInfoID}),
  )

  return (
    <ConfigTextInput
      label="Reason for Return"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      hide={labelType !== LABEL_TYPE_RETURN}
    />
  )
}

ReturnReason.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
